import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StripeConfigService {
    private publishableKey: string | null = null;

    constructor(private http: HttpClient) { }

    async getStripePublicKey(): Promise<string> {
        if (this.publishableKey) {
            return this.publishableKey;
        }
        try {
            const config = await firstValueFrom(
                this.http.get<{ publishableKey: string }>(`${environment.myurl}/api/Payment/GetConfig`)
            );
            this.publishableKey = config.publishableKey;
            return this.publishableKey;
        } catch (error) {
            console.error('Failed to get Stripe publishable key:', error);
            throw new Error('Failed to load Stripe configuration');
        }
    }
}